module.exports = __webpack_public_path__ + "static/img/lv3.b071949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lv3.png
// module id = /P7T
// module chunks = 0